import React, { useState } from "react";
import Carousel from "react-material-ui-carousel";
import "../../backconfig/banner/BannerStyle.scss";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom/cjs/react-router-dom";
import ReactPlayer from "react-player";

const DefaultSettingsT = {
  autoPlay: true,
  animation: "slide",
  duration: 300,
  navButtonsAlwaysVisible: false,
  navButtonsAlwaysInvisible: false,
  cycleNavigation: true,
  fullHeightHover: true,
  interval: 2500,
  swipe: true,
  indicators: false,
  indicatorContainerProps: {
    style: {
      zIndex: 100,
      bottom: "10px",
      position: "relative",
    },
  },
};

const BannerClassicScroll = (props) => {
  const { heroSliderData, userData, forTestOnly, products } = props;
  const [settings, setSettings] = useState(DefaultSettingsT);

  const product6 =
    products && products.length > 0 ? products.slice(0, 4) : null;
  const _history = useHistory();

  const clickMapBanner = (url) => {
    if (url) _history.push(url);
  };

  const BannerItem = (itemProps) => {
    const _i = (
      <Link>
        <img
          src={itemProps.image}
          className="d-block w-100"
          style={{
            width: "100%",
            height: "auto",
            verticalAlign: "middle",
            overflow: "clip",
          }}
          alt="slide image 01"
          onClick={() => clickMapBanner(itemProps?.url)}
        />
      </Link>
    );

    return _i;
  };

  return (
    <div
      style={{
        maxWidth: "100%",
        width: "1500px",
        margin: "auto",
      }}
    >
      <Carousel
        className="BannerStyle"
        {...settings}
        next={(now, previous) =>
          console.log(`next => Movimento a ${now} da ${previous}`)
        }
        prev={(now, previous) =>
          console.log(`prev => Movimento a ${now} da ${previous}`)
        }
        onChange={(now, previous) =>
          console.log(`OnChange Movimento a ${now} da ${previous}`)
        }
        //navButtonsProps={{ style: { backgroundColor: 'cornflowerblue', borderRadius: 0 } }}
        //navButtonsWrapperProps={{ style: { bottom: '0', top: 'unset', } }}
        //indicatorContainerProps={{ style: { margin: "20px" } }}
        //NextIcon='next'
      >
        {itemConvert(heroSliderData).map((item, index) => {
          return <BannerItem {...item} index={index} />;
        })}
      </Carousel>
      {/*<br /> <Settings settings={settings} setSettings={setSettings} />*/}
      {props.noItems ? null : footer(product6)}
    </div>
  );
};

const itemConvert = (_heroSliderData) => {
  return _heroSliderData;
  {
    /*const getPos = (index) => {
    const position = index % 3;
    switch (position) {
      case 0: return 'right';
      case 1: return 'left';
      case 2: return 'middle';
    }
  }
  //{id: 0, timeStamp: '', nameFile: '', image: '', headImage: '', title: '', url: '', buttonCaption: ''}
  const itemsToReturn = _heroSliderData.map((_oldItem, index) => {
    return {
      Name: '',
      Caption: _oldItem.buttonCaption,
      contentPosition: getPos(index),
      Items: [
        {
          Name: "",
          Image: _oldItem.image
        },
        {
          Name: "",
          Image: _oldItem.headImage
        }
      ]
    }
  })

return itemsToReturn;*/
  }
};

const footer = (product6) => {
  if (!product6) return null;
  return (
    <React.Fragment>
      <div
        className="container mb-5"
        style={{
          marginTop: "20px",
          zIndex: 10,
          position: "relative",
          textAlign: "center",
        }}
      >
        {/* <!-- Prouct Row Starts --> */}

        <div className="row">
          {product6.map((_product) => (
            <div className="col-lg-3">
              <div
                className="card my-2 my-lg-0"
                style={{ borderColor: "transparent" }}
              >
                <div className="card-body justify-content-center">
                  <a href="#">
                    <Link
                      to={process.env.PUBLIC_URL + "/product/" + _product.id}
                    >
                      <img
                        id={"image-prod-" + _product.id}
                        //src={(imageExists(global.baseUrlImage + product.image[0]) && product.image[0] != "") ? global.baseUrlImage + product.image[0] : "https://dgaplanetshirt.com/assets/img/logo/logo.png"}

                        src={global.baseUrlImage + _product.image[0]}
                        onError={() => {
                          document.getElementById(
                            "image-prod-" + _product.id
                          ).src = global.placeholderImage;
                          document.getElementById(
                            "image-prod-" + _product.id
                          ).style.objectFit = "contain";
                        }}
                        style={{ height: "30vh", objectFit: "contain" }}
                        alt=""
                      />
                      {/*_product.image.length > 1 ? (
                      <img
                        className="hover-img"
                        src={global.baseUrlImage + _product.image[1]}
                        alt=""
                      />) : (
                      ""
                    )*/}
                    </Link>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* <!-- Prouct Row Ends --> */}
      </div>
    </React.Fragment>
  );
};

export default BannerClassicScroll;
